import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { PipesModule } from "../pipes/pipes.module";
import { ComponentsModule } from "../components/components.module";
import { NgxMaskModule, IConfig } from "ngx-mask";
import { DirectivesModule } from "../directives/directives.module";

@NgModule({
  declarations: [],
  exports: [
    IonicModule,
    ReactiveFormsModule,
    PipesModule,
    FormsModule,
    CommonModule,
    ComponentsModule,
    NgxMaskModule,
    DirectivesModule,
  ],
  imports: [
    PipesModule,
    CommonModule,
    ComponentsModule,
    NgxMaskModule.forChild(),
    DirectivesModule,
  ],
  // schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {}
